import styled from 'styled-components'

import Button from 'components/Button'
import { CTAContainer } from 'components/CTAContainer'
import Layout from 'components/Layout'
import { Body, Footnote, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const ActionWrapper = styled(CTAContainer)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: transparent;
  }
`

export const WrapperBackground = styled.div<{ backgroundUrl: string }>`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background: url(${props => props.backgroundUrl});
    background-repeat: no-repeat;
    background-position: right bottom -140px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 0 auto;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 340px;
    margin: 0 auto 100px;
  }
`

export const StyledTitle = styled(Heading2)`
  font-size: 40px;
  font-weight: 600;
  line-height: 55px;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 6px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 0;
  }
`

export const StyledLayout = styled(Layout)`
  padding: 10px 0px 14px 0px;
`

export const StyledBody = styled(Body)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 35px;
  max-width: 400px;
  text-align: left;
`

export const Wrapper = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`

export const StyledButton = styled(Button)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    height: 44px;
    padding: unset;
    width: 100%;
    max-width: 100vh;
  }
`

export const StyledImage = styled.img`
  bottom: 0;
  position: absolute;
  right: -50px;
`

export const StyledFootnote = styled(Footnote)`
  margin-bottom: 64px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 0;
    max-width: 220px;
  }
`

export const StyledTextButton = styled(Button)`
  line-height: 22px;
  height: 22px;
  margin-top: 20px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 7px;
  }
`
export const AccessibilityContainer = styled.div<{ respectPadding?: boolean }>`
  position: ${({ respectPadding }) => (respectPadding ? 'inherit' : 'fixed')};
  bottom: 20px;
  left: 0;
  color: ${style(theme => theme.colors.white)};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
